// src/reducers/reportSettingsReducer.js

import {
  GET_REPORT_SETTINGS_REQUEST,
  GET_REPORT_SETTINGS_SUCCESS,
  GET_REPORT_SETTINGS_FAIL,
  UPDATE_REPORT_SETTINGS_REQUEST,
  UPDATE_REPORT_SETTINGS_SUCCESS,
  UPDATE_REPORT_SETTINGS_FAIL,
  // ✅ Import the missing CREATE action types
  CREATE_REPORT_SETTINGS_REQUEST,
  CREATE_REPORT_SETTINGS_SUCCESS,
  CREATE_REPORT_SETTINGS_FAIL,
} from '../actions/types';

const initialState = {
  settings: {}, // Initialize as an empty object. The component will handle defaults.
  loading: false,
  error: null,
};

export default function (state = initialState, action) {
  switch (action.type) {
    // --- GROUPED REQUESTS ---
    // Any of these actions will trigger the loading state.
    case GET_REPORT_SETTINGS_REQUEST:
    case CREATE_REPORT_SETTINGS_REQUEST:
    case UPDATE_REPORT_SETTINGS_REQUEST:
      return { ...state, loading: true, error: null };

    // --- GROUPED FAILURES ---
    // Any of these failures will stop loading and set an error.
    case GET_REPORT_SETTINGS_FAIL:
    case CREATE_REPORT_SETTINGS_FAIL:
    case UPDATE_REPORT_SETTINGS_FAIL:
      return { ...state, loading: false, error: action.payload };

    // --- (CORRECTED) Get all settings ---
    // This correctly transforms the API's array into a structured object.
    case GET_REPORT_SETTINGS_SUCCESS:
      const settingsObject = (action.payload.data || []).reduce((acc, setting) => {
        // Use the 'ReportType' from the API data as the key
        acc[setting.ReportType] = setting;
        return acc;
      }, {});
      return {
        ...state,
        loading: false,
        settings: settingsObject,
      };

    // --- (CORRECTED) Handle a successful CREATE or UPDATE ---
    // This logic correctly merges the single returned record into our state object.
    case CREATE_REPORT_SETTINGS_SUCCESS:
    case UPDATE_REPORT_SETTINGS_SUCCESS:
      // The API returns the new/updated setting in `action.payload.data`
      const updatedSetting = action.payload.data;
      
      // Failsafe: Do nothing if the payload is invalid
      if (!updatedSetting || !updatedSetting.ReportType) {
        return { ...state, loading: false }; 
      }
      
      return {
        ...state,
        loading: false,
        settings: {
          ...state.settings,
          // Add or overwrite the setting for the specific ReportType
          // e.g., updates state.settings.prescription with the new data
          [updatedSetting.ReportType]: updatedSetting,
        },
      };

    default:
      return state;
  }
}